<template>
    <div class="second">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div style="height:89.3%;position:relative;overflow:hidden;">
                <div class="searchBox flex flex-align-center">
                    <div class="left search flex flex-align-center tab-item" style="width:120px;">
                        <span class="left-item" :class="{active:nowSelType=='no'}" @click.stop="nowSelType='no'">未开始</span>
                        <span class="left-item" :class="{active:nowSelType=='ing'}" @click.stop="nowSelType='ing'">进行中</span>
                        <span class="left-item" :class="{active:nowSelType=='over'}" @click.stop="nowSelType='over'">已结束</span>
                        <span class="left-item" :class="{active:nowSelType=='cancel'}" @click.stop="nowSelType='cancel'">已取消</span>
                    </div>
                    <div class="searchCon clearfix">
                        <div class="right searchBtn">
                            <button type="button" @click="modifySecond"><i class="el-icon-plus"></i>新增优惠</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox" style="height:87%;">
                    <div class="tableBoxScroll">
                        <table class="titleTable jobTitleTable">
                            <tr>
                                <th style="width:10%" class="">名称</th>
                                <th style="width:10%" class="">优惠方式</th>
                                <th style="width:15%" class="">减免金额/折扣</th>
                                <th style="width:25%" class="">优惠生效时间</th>
                                <th style="width:15%" class="">时间范围</th>
                                <th style="width:20%" class="">星期</th>
                                <th style="width:15%" class="">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable jobConTable" :class="{overLengthTable:dataList.length>pageSize}">
                                    <tr v-for="item in dataList">
                                        <td style="width:10%" class="" v-text="item.name"></td>
                                        <td style="width:10%" class="" >{{typeOptions[item.discountType]}}</td>
                                        <td style="width:15%" class="">{{formatDiscount(item)}}</td>
                                        <td style="width:25%" class="">{{formatTime(item)}}</td>
                                        <td style="width:15%" class="">{{formatTimeRange(item)}}</td>
                                        <td style="width:20%" class="">
                                            {{item.week}}
                                        </td>
                                        <td style="width:5%">
                                            <div v-if="item.id" class="btnInline">
                                                <span style="color:blue;cursor:pointer;" @click.stop="detail(item)">详情</span>
                                                <!-- <span title="修改" @click="getCurJob(item)"><i class="iconfont icon-bianji"></i></span>
                                                <span title="删除" @click="delJob(item.id)"><i class="iconfont icon-icon1460188478041"></i></span> -->
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <cartInfo
                    @closeCartInfo="closeCartInfo"
                    :showType="'secondActivity'"
                    :secondInfo="secondInfo"
                    :storeId="curStoreId"
                    :showCartInfo="showCartInfo"/>
                </div>
                </div>
                
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="nowPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            :title="curJobId?'修改时段':'添加时段'"
            :visible.sync="addJobVisible"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>名称</span>
                        <input type="text" class="left itemInput" v-model="timeName" placeholder="请输入时段名称">
                    </div>
                    <div class="left msgItem clearfix groupRoles">
                        <span class="left itemName permissions"><i>*</i>开始时间</span>
                        <div class="left">
                            <div class="rowItem">
                                <el-input
                                    style="width:80px"
                                  placeholder="请输入时"
                                  v-model="time.beginHour"
                                  clearable>
                                </el-input>
                                <span style="color:red;">时</span>
                                <el-input
                                    style="width:80px"
                                   placeholder="请输入分"
                                  v-model="time.beginMinute"
                                  clearable>
                                </el-input>
                                <span style="color:red;">分</span>
                            </div>
                        </div>
                    </div>
                    <div class="left msgItem clearfix groupRoles" style="margin-top:20px;">
                        <span class="left itemName permissions"><i>*</i>结束时间</span>
                        <div class="left">
                                <div class="rowItem">
                                    <el-input
                                        style="width:80px"
                                        placeholder="请输入时"
                                        v-model="time.endHour"
                                        clearable>
                                    </el-input>
                                    <span style="color:red;">时</span>
                                    <el-input
                                        style="width:80px"
                                      placeholder="请输入分"
                                      v-model="time.endMinute"
                                      clearable>
                                    </el-input>
                                    <span style="color:red;">分</span>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addJob" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import cartInfo from "./../../../cartInfo/cartInfo";
    export default{
        props: ['curStoreId'],
        components:{cartInfo},
        data () {
            return {
                secondInfo:{},
                showCartInfo:false,
                totalElements:0,
                typeOptions:{
                    "discount":"折扣",
                    "reduce":"减免金额",
                },
                nowPage:1,
                pageSize:10,
                nowSelType:"ing",//over结束，//cancel取消,ing进行中
                dataList: [], // 岗位列表
                timeName:'',
                curJobId: '', // 时段id
                addJobVisible: false, // 控制新增弹框显示隐藏
                addJobApiBtn: true, // 控制新增岗位接口
                time:{
                    beginHour:'',
                    beginMinute:'',
                    endHour:'',
                    endMinute:''
                }
            }
        },
        watch:{
          nowSelType(val){
              this.getList();
          },
          nowPage(val){
              this.getList();
          }
        },
        methods: {
            closeCartInfo(){
                this.showCartInfo=false;
                this.getList();
            },
            detail(item){
                this.$http({
                    url:"dp/detail",
                    method:"GET",
                    params:{
                        id:item.id
                    }
                }).then(res=>{
                    this.secondInfo = res.data;
                    this.showCartInfo = true;
                });
            },
            getGoodsInfo(item){
                this.$http({
                    url:"dp/product/list",
                    method:"GET",
                    params:{
                        promotionId:item.id,
                        page:this.nowPage,
                        size:this.pageSize
                    }
                }).then(res=>{
                });
            },
            //分页方法
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.nowPage = val;
            },
            formatTimeRange(item){
                if(item.beginHour && item.endHour){
                    return `${item.beginHour}至${item.endHour}`;
                }else{
                    return '';
                }
            },
            formatTime(item){
                if(item.timeType == "forever"){
                    return '永久有效';
                }else if(item.timeType == "custom"){
                    return `${new Date(item.beginTime).Format("yyyy-MM-dd")}至${new Date(item.endTime).Format("yyyy-MM-dd")}`;
                }
            },
            formatDiscount(item){
                if(item.discountType == "discount"){
                    return `${item.discount / 10}折`;
                }else if(item.discountType == "reduce"){
                    return `${item.reduceAmount / 100}元`;
                }
            },
            modifySecond(){
                this.$router.push({
                    path:`/sys/${this.curStoreId}/modifySecond`
                })
            },
            // 获取岗位列表
            getList: function () {
                this.$http({
                    url:"dp/list",
                    method:"GET",
                    params:{
                      storeId:this.curStoreId,  
                      type:this.nowSelType,
                      page:this.nowPage - 1,
                      size:this.pageSize
                    }
                }).then(res=>{
                    this.dataList = res.data.content;
                    this.totalElements = res.data.totalElements;
                    let number = this.pageSize - this.dataList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.dataList.push({
                                name:''
                            });
                        }
                    }
                })
                // this.$http.get('/product-supply-time?storeId='+this.curStoreId).then((res)=>{
                //     this.dataList = res.data;
                //     for (let i = 0; i <  this.dataList.length; i++) {
                //         if(this.dataList[i].id){
                //             this.dataList[i].time = (this.dataList[i].beginHour<10?'0'+this.dataList[i].beginHour:this.dataList[i].beginHour)+':'
                //             +(this.dataList[i].beginMinute<10?'0'+this.dataList[i].beginMinute:this.dataList[i].beginMinute)+'~'
                //             +(this.dataList[i].endHour<10?'0'+this.dataList[i].endHour:this.dataList[i].endHour)+':'
                //             +(this.dataList[i].endMinute<10?'0'+this.dataList[i].endMinute:this.dataList[i].endMinute)
                //         }
                //     }
                //     let number = this.pageSize - this.dataList.length;
                //     if ( number > 0 ) {
                //         for (let i = 0; i < number; i++) {
                //             this.dataList.push({
                //                 name:''
                //             });
                //         }
                //     }
                // }).catch((err)=>{

                // })
            },
            // 新增, 更新岗位
            addJob: function () {
                if(!this.timeName){
                    this.$message({
                        message: '请输入时段名',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.beginHour.length>2||parseInt(this.time.beginHour)>23||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginHour))){
                    this.$message({
                        message: '开始小时数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.beginMinute.length>2||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginMinute))||parseInt(this.time.beginMinute)>59){
                    this.$message({
                        message: '开始分钟数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.endHour.length>2||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endHour))||parseInt(this.time.endHour)>23){
                    this.$message({
                        message: '结束小时数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.endMinute.length>2||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endMinute))||parseInt(this.time.endMinute)>59){
                    this.$message({
                        message: '结束分钟数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.addJobApiBtn ) {
                    return;
                }
                this.addJobApiBtn = false;
                let body = {
                    id:this.curJobId?this.curJobId:this.$uuid.create(1).hex,
                    storeId:this.curStoreId,
                    name:this.timeName,
                    beginHour:parseInt(this.time.beginHour),
                    beginMinute:parseInt(this.time.beginMinute),
                    endHour:parseInt(this.time.endHour),
                    endMinute:parseInt(this.time.endMinute)
                }
                this.$http.post('/product-supply-time',body).then((res)=>{
                    this.addJobVisible = false;
                    this.addJobApiBtn = true;
                    this.getList();
                    this.$message({
                        message: '操作成功',
                        customClass: 'success'
                    })
                }).catch((err)=>{
                    this.addJobApiBtn = true;
                })
            },
            // 删除岗位
            delJob: function ( jobId ) {
                this.$confirm('此操作将删除该时段, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除岗位
                    this.$http.delete('/product-supply-time?id='+jobId).then((res)=>{
                        this.$message({
                            message: '删除成功',
                            customClass: 'success'
                        })
                        this.getList();
                    }).catch((err)=>{
                        
                    })
                }).catch(() => {});
            },
            // 获得当前岗位信息
            getCurJob: function ( item ) {
                this.curJobId = item.id;
                this.timeName = item.name;
                this.time = {
                    beginHour:item.beginHour,
                    beginMinute:item.beginMinute,
                    endHour:item.endHour,
                    endMinute:item.endMinute
                }
                this.addJobVisible = true;
            },
            // 清除信息
            clear: function () {
                this.timeName = '';
                this.time = {
                    beginHour:'',
                    beginMinute:'',
                    endHour:'',
                    endMinute:''
                }
                this.checkedCities = [];
                this.curJobId = '';
                this.addJobVisible = true;
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.dataList.push({
                    name:''
                });
            }
        },
        activated: function () {
            this.getList();
        }
    }
</script>
<style lang="scss">
    @import './../../../../../static/css/common.scss';
    @import './../../../tableTemplate/tableTem.scss';
    @import './../../../tableTemplate/el-dialog.scss';
    @import "second";
</style>



// WEBPACK FOOTER //
// second.vue?6d2b5fd7